import { connect } from 'react-redux';
import { FriendRequests } from './FriendRequests';
import { fetchFriendRequests } from '../../actions/friendRequestsAction';

const mapStateToProps = (state) => ({
  friendRequests: state.friendRequests,
  currentUser: state.currentUser,
});
const mapDispachToProps = (dispatch) => ({
  onFriendRequestsFetch: (currentUserID) => dispatch(fetchFriendRequests(currentUserID)),
});

export default connect(mapStateToProps, mapDispachToProps)(FriendRequests);
